import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'timezoneConversion',
})
export class TimezoneConversionPipe implements PipeTransform {
	transform(utcDate: string): string {
		const localDate = new Date(utcDate + 'Z'); // Append 'Z' to indicate UTC
		return localDate.toLocaleString();
	}
}
